import { BaseMaskAdapter } from "./base-adapter";

export class CurrencyPresetAdapter extends BaseMaskAdapter {
  private readonly formatter = new Intl.NumberFormat("es-AR", {
    currency: "ARS",
    currencyDisplay: "symbol",
    style: "currency",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  constructor() {
    super("");
  }

  formatForDisplay(value: unknown): string {
    if (this.isEmpty(value)) {
      return "";
    }
    return this.formatter.format(Number(value));
  }

  parseFromInput(inputValue: string): { value: number; formatted: string } {
    const digits = this.cleanNumericInput(inputValue);
    if (!digits) {
      return { value: 0, formatted: "" };
    }

    const numericValue = Number(digits) / 100;
    return {
      value: numericValue,
      formatted: this.formatter.format(numericValue),
    };
  }

  handleControlledUpdate(value: unknown): string {
    if (this.isEmpty(value)) {
      return "";
    }
    return this.formatter.format(Number(value));
  }

  isKeyAllowed(key: string): boolean {
    if (this.isControlKey(key)) {
      return true;
    }
    return /^\d$/.test(key);
  }
}
